@import '../../../theme/mixins';
@import '../../../theme/colors';

.ticketModal {
  width: 703px;
  height: 80%;
  margin: auto;

  .container {
    background-color: $white;
    width: 100%;
    height: 100%;
    padding: 10px 40px 10px 30px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    & > i {
      position: absolute;
      right: 10px;
      top: 3px;
      color: #595959;
      cursor: pointer;
    }

    .commentForm {
      width: 100%;

      form {
        display: flex;
        flex-direction: column;
        margin-block-end: 0;

        .textbox {
          height: 98px;

          & > div {
            width: 100% !important;
          }
        }

        .buttons {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;

          .filePicker {
            display: flex;
            align-items: center;
            input {
              width: 0.1px;
              height: 0.1px;
              opacity: 0;
              overflow: hidden;
              position: absolute;
              z-index: -1;
            }

            .fileName {
              display: flex;
              align-items: center;
              max-width: 185px;
              margin-right: 10px;

              span {
                @include body1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              i {
                font-size: 20px;
                cursor: pointer;
              }
            }

            .uploadButton {
              width: 155px !important;
              height: 40px !important;
              border-radius: 2px !important;
              padding-top: 0 !important;
              padding-bottom: 0 !important;
              cursor: pointer !important;
              font-size: 13px !important;
              font-family: var(--font-family__heading) !important;
              line-height: 1 !important;
              text-transform: uppercase !important;
              color: $oceanBlue;
            }

            .uploadButton:hover {
              background-color: #def3ff !important;
            }
          }
        }
      }
    }

    .header {
      display: flex;
      align-items: flex-end;
      border-bottom: 1px solid $neutral-200;

      .status {
        @include body1;
        display: flex;
        align-items: center;
        min-width: max-content;

        .label {
          font-family: var(--font-family__heading);
          font-size: 11px;
          font-weight: 200;
          color: $neutral-600;
          letter-spacing: normal;
          margin-right: 5px;
          margin-top: 2px;
        }
      }
    }
  }

  .center {
    height: calc(100% - 225px);

    .noResults {
      @include body1;
      margin: 10px 0;
      display: block;
    }

    .details {
      border-bottom: 1px solid $neutral-200;

      & > div {
        margin: 6px 0;
      }
    }

    .filesSection {
      margin: 15px 0;

      .files {
        @include label4;
        border: 1px dotted $lighterGrey;
        border-radius: 4px;
        width: 330px;
        display: flex;
        flex-direction: column;
        padding: 10px;
        margin: 10px 0;

        a {
          @include caption;
          color: $neutral-600;
          max-width: 95%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 5px 0;
        }

        a:hover {
          color: $lighterGrey;
        }

        a::after {
          content: '\A';
        }
      }
    }

    .commentsSection {
      .header {
        display: flex;
        align-items: center;
        border-bottom: none;

        h6 {
          margin-right: 20px;
        }
      }

      .commentsMap {
        @include body1;

        .commentWrapper {
          display: flex;
          border-top: 1px solid $neutral-200;
          padding: 7px 0;

          .author {
            min-width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .commentDetails {
            display: flex;
            flex-direction: column;
            margin-left: 25px;
            width: 80%;

            span:first-child {
              font-weight: 500;
              margin-bottom: 4px;
            }

            a {
              color: $neutral-600;
              overflow: hidden;
              max-width: 80%;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0;
              display: block;
            }

            a:hover {
              color: $lighterGrey;
            }

            a::before {
              content: '\A';
            }
          }
        }
      }
    }
  }
}
